import React from 'react';

/**
 * Wrapper component for form inputs that provides consistent label and error display
 */
const InputWrapper = ({
  field,
  label,
  isRequired,
  error,
  children,
  showError = true
}) => {
  const labelOnSameRow = field.labelOnSameRow === true;

  if (labelOnSameRow) {
    return (
      <div className="formulaire-dynamique-main-div form-field-group">
        <div className={`formulaire-dynamique-div input-container ${field.texteVertical && 'formulaire-dynamique-label-wrapper'}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <span className="formulaire-dynamique-span" style={{
            marginBottom: 0, flexShrink: 0,
            minWidth: '200px', maxWidth: '200px' //Enlever pour laisser le label prendre toute la largeur
          }}>
            {label}{isRequired ? '*:' : ':'}
          </span>
          <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
            {children}
          </div>
          {showError && error && (
            <span className="color-error formulaire-dynamique-span" style={{ width: '100%', marginTop: '5px' }}>{error}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="formulaire-dynamique-main-div form-field-group">
      <div className={`formulaire-dynamique-div ${field.texteVertical && 'formulaire-dynamique-label-wrapper'}`}>
        <span className="formulaire-dynamique-span">
          {label}{isRequired ? ' *' : ''} :
        </span>
      </div>
      <div className="formulaire-dynamique-div input-container">
        {children}
        {showError && error && (
          <span className="color-error formulaire-dynamique-span">{error}</span>
        )}
      </div>
    </div>
  );
};

export default InputWrapper;

